import { Injectable } from '@angular/core';
import { Product } from '@shared/models/products.model';
import { ProductsBaseService } from '../products-base.service';
import { ProductsTransformService } from '../products-transform.service';
import { generateProductRequisites } from '../requisites/generate-requisites';

@Injectable({
  providedIn: 'root'
})
export class GetProductRequisitesCommand {
  constructor(
    private productsBase: ProductsBaseService,
    private productsTransform: ProductsTransformService
  ) {}

  execute(id: string) {
    const product = this.productsBase.findProductById(this.productsBase.products, id);
    const title = this.productsTransform.getProductInfo(product, product.productType);

    return {
      title,
      requisites: generateProductRequisites(product),
      id
    };
  }
}
